export default [
  {
    action: "manage",
    resource: "all",
    header: "Comptabilitat",
  },
  {
    action: "manage",
    resource: "all",
    icon: "CreditCardIcon",
    title: "Pagaments",
    children: [
      {
        title: "Llistat",
        route: "foravila-accounting-payments-all",
      },
      {
        title: "Verificació",
        route: "foravila-accounting-payments-verify",
      },
      {
        title: "Tresoreria diària",
        route: "foravila-accounting-payments-daily-cash",
      },
      {
        title: "Targetes virtuals",
        route: "foravila-accounting-payments-virtual-cards",
      },
    ],
  },
  {
    action: "manage",
    resource: "all",
    icon: "DollarSignIcon",
    title: "Facturació",
    children: [
      {
        title: "Factures pendents",
        route: "foravila-accounting-billing-pending-invoices-list",
      },
      {
        title: "Factures emeses",
        route: "foravila-accounting-billing-issued-invoices-list",
      },
      {
        title: "Liquidacions pendents",
        route: "foravila-accounting-billing-pending-liquidations-list",
      },
      {
        title: "Liquidacions emeses",
        route: "foravila-accounting-billing-issued-liquidations-list",
      },
    ],
  },
  {
    action: "manage",
    resource: "all",
    icon: "SettingsIcon",
    title: "Configuració",
    children: [
      {
        title: "Sèries de factures",
        route: "foravila-accounting-invoice-numberings-list",
      },
      {
        title: "C.C. generals",
        route: "foravila-accounting-global-ledger-accounts",
      },
      {
        title: "C.C. d'allotjaments",
        route: "foravila-accounting-accommodations-ledger-accounts",
      },
    ],
  },
];
